/*
 * @Description: 
 * @Author: knx-xc
 * @LastEditTime: 2020-07-31 12:40:01
 * @LastEditors: knx-xc
 */
import http from '../http';
/**
 * @description:  友情链接-列表
 * @params ：  
 */

export var friendly_list = function friendly_list() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: 'manage/friendlyLink/list',
    data: data,
    formData: true
  };
  return http(params);
};
/**
 * @description:  友情链接-信息
 * @params ：  
 */

export var friendly_info = function friendly_info() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: 'manage/friendlyLink/info' + data.id,
    data: data
  };
  return http(params);
};
/**
 * @description:  客户信息-保存
 * @params ：  
 */

export var friendly_save = function friendly_save() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: 'manage/friendlyLink/save',
    data: data
  };
  return http(params);
};
/**
 * @description:  客户信息-修改
 * @params ：  
 */

export var friendly_update = function friendly_update() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: 'manage/friendlyLink/update',
    data: data
  };
  return http(params);
};
/**
 * @description:  客户信息-删除
 * @params ：  ids []
 */

export var friendly_delete = function friendly_delete() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: 'manage/friendlyLink/delete',
    data: data
  };
  return http(params);
};